<script setup>
import { cn } from '@/lib/utils';

const props = defineProps({
    class: { type: null, default: '' },
});
</script>

<template>
    <h3 :class="cn('text-2xl font-semibold leading-none tracking-tight', props.class)">
        <slot />
    </h3>
</template>
